module.exports = __webpack_public_path__ + "img/a.29da8cd3.svg";